import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography
} from '@mui/material';
import { useState } from "react";
import { IProdutoPedido } from '../../../pedidos/interface/IProdutoPedido';
import { IProduto } from "../../interfaces/IProduto";
import { DrawerPesoOperacao } from '../DrawerPesoOperacao';
import { useMoeda } from '../../../core/hooks/useMoeda';
import { useLetras } from '../../../core/hooks/useLetras';

interface CardPesoOperacaoProps {
  produto: IProduto;
  adicionarProduto: (produto: IProdutoPedido) => void;
  modoTeclado?: boolean;
  isSelecionado?: boolean;
  onCustomize?: (produto: IProduto) => void;
}

export const CardPesoOperacao = ({ produto, adicionarProduto, modoTeclado = false, isSelecionado = false, onCustomize }: CardPesoOperacaoProps) => {
  const [open, setOpen] = useState(false);
  const { real } = useMoeda();
  const { maiusculas } = useLetras();

  const handleClick = () => {
    if (onCustomize) {
      return onCustomize(produto);
    }
    setOpen(true);
  };

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <>
      <Card
        sx={{
          maxWidth: 300,
          height: 250,
          ...(isSelecionado && {
            border: '3px solid',
            borderColor: 'primary.main',
            boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)',
            transform: 'scale(1.02)',
            transition: 'all 0.2s ease-in-out'
          })
        }}
        variant='outlined'
        onClick={handleClick}
      >
        <CardActionArea sx={{ height: "100%", width: "100%" }}>
          {produto.imagens?.length ? (
            <CardMedia
              component="img"
              height="140px"
              image={`${produto.imagens[0].url}`}
              sx={{ objectFit: "cover" }}
              alt={produto.descricao}
            />
          ) : (
            <CardMedia
              component="img"
              height="140px"
              image={`${process.env.PUBLIC_URL}/images/produtos/preparado.png`}
              sx={{ objectFit: "contain" }}
              alt={produto.descricao}
            />
          )}
          <CardContent sx={{ height: "100%" }}>
            <Typography gutterBottom variant="subtitle2" fontWeight={"bold"} component="div">
              {maiusculas(produto.descricao, 25)}
            </Typography>
            <Typography gutterBottom variant="body2" color="text.secondary" component="div">
              {real((produto.configuracaoPeso ?? produto.configuracao)?.precoPorKg)} / kg
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
      {!onCustomize && (
        <DrawerPesoOperacao
          open={open}
          toggleDrawer={toggleDrawer}
          produto={produto}
          onSubmit={adicionarProduto}
        />
      )}
    </>
  );
};
